// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminUser_container__2lp1s","button":"AdminUser_button__3TahI","avatar":"AdminUser_avatar__2EHX5"};